<div>
  <mat-form-field class="time-frame-selector">
    <mat-select
      [placeholder]="!ignorePlaceholder ? (timeRangePlaceholder | translate) || 'Time Range' : undefined"
      [ngModel]="timeRangeOption"
      (selectionChange)="onTimeRangeChange($event.value)"
    >
      <mat-option *ngFor="let option of timeRangeOptions" [value]="option.key">
        {{ option.name | translate: { dateRange: option.dateString } }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <mat-form-field *ngIf="timeRangeOption === 'custom'">
      <input
        matInput
        [matDatepicker]="startPicker"
        [placeholder]="(customStartDatePlaceholder | translate) || 'Start date'"
        (dateChange)="onStartChange($event.value)"
        [value]="dateRange[0]"
        [max]="dateRange[1]"
        [min]="min"
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field *ngIf="timeRangeOption === 'custom'">
      <input
        matInput
        [matDatepicker]="endPicker"
        [placeholder]="(customEndDatePlaceholder | translate) || 'End date'"
        (dateChange)="onEndChange($event.value)"
        [value]="dateRange[1]"
        [min]="dateRange[0]"
        [max]="max"
      />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
